import { Flex } from 'antd'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import Icon from '@/components/icon'
import styles from './style.module.scss'
import 'swiper/css'
import 'swiper/css/navigation'

interface SlideData {
  title: string
  position: string
  description: string[]
}

// team 介绍轮播图
const SwiperCarousel = ({ data }: { data: SlideData[] }) => {
  return (
    <Flex align='center' className={styles.container}>
      <Swiper
        modules={[Navigation]}
        navigation={{
          prevEl: `.${styles.prev}`,
          nextEl: `.${styles.next}`,
        }}
        slidesPerView={3}
        centeredSlides
        spaceBetween={20}
        initialSlide={0}
        loop
        onSlideChange={() => console.log('slide change')}
      >
        {data.map((slide, index) => (
          <SwiperSlide key={index}>
            {({ isActive }) => (
              <div className={`${styles.slide} ${isActive ? styles.active : ''}`}>
                <div className={styles.content}>
                  <div className={styles.title}>{slide.title}</div>
                  <div className={styles.position}>{slide?.position}</div>
                  <p className={styles.description}>{slide?.description?.join('\n')}</p>
                </div>
              </div>
            )}
          </SwiperSlide>
        ))}

        {/* 自定义导航按钮 */}
        <Icon name='arrowBlack' className={`${styles.navigation} ${styles.prev}`}></Icon>
        <Icon name='arrowBlack' className={`${styles.navigation} ${styles.next}`}></Icon>
      </Swiper>
    </Flex>
  )
}

export default SwiperCarousel
